if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"players","remotes":[{"alias":"core","name":"core","entry":"https://core.mancity.com/_next/static/chunks/remoteEntry.js","shareScope":"default","externalType":"script"}],"shareStrategy":"loaded-first"},
		chunkMatcher: function(chunkId) {return !/^(178|180|231|343|369|435|464|596|639|70|786|803|921)$/.test(chunkId)},
		rootOutputDir: "../../",
		bundlerRuntimeOptions: { remotes: { remoteInfos: {"core":[{"alias":"core","name":"core","entry":"https://core.mancity.com/_next/static/chunks/remoteEntry.js","shareScope":"default","externalType":"script"}]}, webpackRequire: __webpack_require__,idToRemoteMap: {}, chunkMapping: {},idToExternalAndNameMapping: {} } }
	};
__webpack_require__.consumesLoadingData = {}
__webpack_require__.remotesLoadingData = {}
}